module.exports = __webpack_public_path__ + "img/pay.50f92ec2.png";